/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ExportJobDto,
  ExportJobDtoPagedList,
  GetApiV1ExportsParams,
  ProblemDetails,
  RequestExportCommand
} from '.././model';

import { request } from '../../http-client';




export const postApiV1Exports = (
    requestExportCommand: RequestExportCommand,
 signal?: AbortSignal
) => {
      
      
      return request<ExportJobDto | ExportJobDto>(
      {url: `/api/v1/exports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestExportCommand, signal
    },
      );
    }
  


export const getPostApiV1ExportsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1Exports>>, TError,{data: RequestExportCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1Exports>>, TError,{data: RequestExportCommand}, TContext> => {

const mutationKey = ['postApiV1Exports'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1Exports>>, {data: RequestExportCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1Exports(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ExportsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1Exports>>>
    export type PostApiV1ExportsMutationBody = RequestExportCommand
    export type PostApiV1ExportsMutationError = ProblemDetails

    export const usePostApiV1Exports = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1Exports>>, TError,{data: RequestExportCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1Exports>>,
        TError,
        {data: RequestExportCommand},
        TContext
      > => {

      const mutationOptions = getPostApiV1ExportsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiV1Exports = (
    params?: GetApiV1ExportsParams,
 signal?: AbortSignal
) => {
      
      
      return request<ExportJobDtoPagedList>(
      {url: `/api/v1/exports`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetApiV1ExportsQueryKey = (params?: GetApiV1ExportsParams,) => {
    return [
    `/api/v1/exports`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiV1ExportsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1Exports>>, TError = unknown>(params?: GetApiV1ExportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Exports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ExportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1Exports>>> = ({ signal }) => getApiV1Exports(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1Exports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ExportsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1Exports>>>
export type GetApiV1ExportsQueryError = unknown


export function useGetApiV1Exports<TData = Awaited<ReturnType<typeof getApiV1Exports>>, TError = unknown>(
 params: undefined |  GetApiV1ExportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Exports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Exports>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Exports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Exports<TData = Awaited<ReturnType<typeof getApiV1Exports>>, TError = unknown>(
 params?: GetApiV1ExportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Exports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Exports>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Exports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Exports<TData = Awaited<ReturnType<typeof getApiV1Exports>>, TError = unknown>(
 params?: GetApiV1ExportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Exports>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1Exports<TData = Awaited<ReturnType<typeof getApiV1Exports>>, TError = unknown>(
 params?: GetApiV1ExportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Exports>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ExportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiV1ExportsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return request<ExportJobDto>(
      {url: `/api/v1/exports/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1ExportsIdQueryKey = (id?: string,) => {
    return [
    `/api/v1/exports/${id}`
    ] as const;
    }

    
export const getGetApiV1ExportsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ExportsId>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ExportsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ExportsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ExportsId>>> = ({ signal }) => getApiV1ExportsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ExportsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ExportsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ExportsId>>>
export type GetApiV1ExportsIdQueryError = ProblemDetails


export function useGetApiV1ExportsId<TData = Awaited<ReturnType<typeof getApiV1ExportsId>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ExportsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ExportsId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ExportsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ExportsId<TData = Awaited<ReturnType<typeof getApiV1ExportsId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ExportsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ExportsId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ExportsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ExportsId<TData = Awaited<ReturnType<typeof getApiV1ExportsId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ExportsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ExportsId<TData = Awaited<ReturnType<typeof getApiV1ExportsId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ExportsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ExportsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




